import './label.css';


export default function Label({text, children}){
    return (
        <div className="label-container">
            {children}
            <p className="label-text" style={{marginLeft: !children ? 0 : 10}}>{text}</p>
        </div>
    )    
}